import axios from "axios";
import { Apis, BaseUrl } from "../../config";
import { getSession } from "../authActions";
import { toast } from "react-toastify";

export const patientList = () => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "patient_List_req" });
  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.patientlist}${user_profile_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { sys_user_id: user_profile_id, role_id: role_id },
      }
    );
    dispatch({ type: "patient_List_Success", payload: response.data });
  } catch (error) {
    dispatch({
      type: "patient_List_failure",
      payload: error?.response?.data,
    });

    toast.error(error?.response?.data?.usr?.message);
  }
};

export const deletePatient = (patient_id) => async (dispatch) => {
  const { token, role_id } = getSession();

  dispatch({ type: "patient_req_delete" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.updatePatient}${patient_id}`,
      {
        svc_active_yn: "N",
        sys_user_id: patient_id,
        role_id: role_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "patient_delete", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    console.log(error);
    dispatch({
      type: "patient_delete_failure",
      payload: error.response.data,
    });

    toast.error(error.response.data.usr.message);
  }
};

export const createPatient = (values) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "add_patient_req" });
  try {
    const response = await axios.post(`${BaseUrl}${Apis.newPatient}`, values, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: "add_patient_success", payload: response.data });
    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "add_patient_failure",
      payload: error.response.data.usr.message,
    });

    toast.error(error.response.data.usr.message);
  }
};

export const editPatient = (values, patientId) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "edit_patient_req" });
  try {
    const response = await axios.put(
      `${BaseUrl}${Apis.newPatientList}${patientId}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "edit_patient_success", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "edit_patient_failure",
      payload: error.response.data,
    });

    //toast.error(error.response.data.usr.message);
  }
};

export const setCurrentData = (data) => (dispatch) => {
  dispatch({ type: "set_patient_details", payload: data });
};
export const addPatients = (values, history) => async (dispatch) => {
  const { token } = getSession();

  dispatch({ type: "add_patient_req" });
  try {
    const response = await axios.post(`${BaseUrl}svcUserPro`, values, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: "add_patient_Sucess", payload: response.data });

    toast.success(response.data.usr.message);
  } catch (error) {
    dispatch({
      type: "add_patient_failure",
      payload: error.response.data.usr.message,
    });

    toast.error(error.response.data.usr.message);
  }
};
